import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import "../../statusIcon.css";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import "../ListDetail.css";
import { downloadInvoice, invoiceIsDue } from "../../redux/invoices/invoicesActions";
import { formatStatus, getColorFromStatusLabel } from "../../redux/invoices/invoicesStatusActions";
import InvoiceStatusIcon from "./InvoiceStatusIcon";
import { getCurrentFunctionName } from "../../performanceModeManager";
import { Typography } from "@material-ui/core";
import { formatType } from "../../redux/invoices/invoicesTypesActions";
import { formatAmountToString } from "../../utils";

const styles = {
	cardActions: {
		padding: 1,
		width: "100%",
		display: "flex",
		flexDirection: "row-reverse",
		justifyContent: "space-between",
		marginTop: "10px",
		paddingLeft: "15px",
	},
	smallButton: {
		width: "130px",
		margin: "0 20px 0 0",
		padding: 0,
	},
	icon: {
		fontSize: 18,
	},
	btnGo: {
		maxHeight: "35px",
	},
};

class InvoiceListDetail extends Component {

	downloadInvoice() {
		this.props.downloadInvoice(this.props.invoice, this.props.activeUser);
	}

	render() {
		console.perfLog(getCurrentFunctionName());

		return (
			<div className="col-lg-4 col-md-4 col-sm-6 col-12 div-card">
				<div ref={(divRef) => (this.divRef = divRef)}>
					<Card className={"col-lg-12 col-md-12 col-sm-12 col-12 card list-detail-card card-margin-top without-side-padding"}>

						<CardContent
							className="without-padding card-content-left-align"
							onClick={this.downloadInvoice.bind(this)}
						>
							<div>
								<div className="row">
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 row">
										<div className={"without-side-padding "/*+ (invoiceIsDue(this.props.invoice) ? "red-flashy-text" : "blue-text")} >*/}>
											<Typography variant="h6">
												{this.props.invoice.number ? this.props.invoice.number : ""}
											</Typography>
										</div>
									</div>
								</div>
								<div className="row card-body-margin">
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding span-center-verticaly card-div-border-right">
										<div className="span-center">
											<span>
												{this.props.invoice.date_invoice.format(
													"DD/MM/YYYY"
												)}
											</span>
										</div>
									</div>
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding row">
										{/* <div className="span-center bold">
											<div className="row">
												<InvoiceStatusIcon state={this.props.invoice.state} type={this.props.invoice.type} />
												<span className={"status-icon-color-" + getColorFromStatusLabel(this.props.invoice.state, this.props.invoice.type, false)} >
													{formatStatus(this.props.invoice.state)}
												</span>
											</div>
										</div> */}
									</div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
										<div className="col-lg-12 col-md-12 col-sm-12 col-12 row card-divider-div"></div>
										<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding span-center-verticaly card-div-border-right">
											<div className="span-center">
												<span className="bold">
													{formatAmountToString(this.props.invoice.amount_untaxed)}
												</span>
											</div>
										</div>
										<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding">
											<div className="span-center bold">
												<span>{formatType(this.props.invoice.type)}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</CardContent>
					</Card>
				</div>
			</div >
		);
	}
}

const mapStateToProps = (state) => {
	return {
		activeUser: state.activeUser,
		invoices: state.invoices,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		downloadInvoice: (invoice, user) => dispatch(downloadInvoice(invoice, user)),
	};
};

export default compose(
	withRouter,
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps)
)(InvoiceListDetail);
